<template>
  <div>
    <!--<span class="header">Next Speakers</span>-->
  <div class="speakers-list-compact" :class="`screen-${screen}`">
    <div class="inner">
      <Carousel
        :autoplay="true"
        :loop="true"
        :per-page="perPage"
        :pagination-enabled="false"
        :autoplay-hover-pause="false"
        :autoplay-timeout="10000"
        :touch-drag="false"
        :mouse-drag="false">
        <Slide key="slide-for">
          <ul>
            <li class="opinion opinion-for">For</li>
            <li v-for="speaker in speakersFor" :key="speaker.id" class="speaker-name">{{speaker.delegate.getName()}}</li>
            <li v-if="numRemainingSpeakersFor > 0" class="speaker-more">...</li>
          </ul>
        </Slide>
        <Slide key="slide-against">
          <ul>
            <li class="opinion opinion-against">Against</li>
            <li v-for="speaker in speakersAgainst" :key="speaker.id" class="speaker-name">{{speaker.delegate.getName()}}</li>
            <li v-if="numRemainingSpeakersAgainst > 0" class="speaker-more">...</li>
          </ul>
        </Slide>
      </Carousel>
    </div>
    <!--<div class="fade"></div>-->
  </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import HasCurrentMotion from '../../mixins/has-current-motion'
import SpeakerState from '../../enums/speaker-state'
import MotionState from '../../enums/motion-state'
export default {
  name: 'SpeakersListCompact',
  mixins: [
    HasCurrentMotion
  ],
  components: {
    Carousel,
    Slide
  },
  props: {
    screen: {
      type: String,
      default: 'one'
    },
    limit: {
      type: Number
    }
  },
  computed: {
    shouldShow () {
      if (!this.$store.getters['settings/showSpeakersOnScreen']) {
        return false
      }
      if (!this.motion) {
        return false
      }
      if (this.motion.name === '') {
        return false
      }
      if (this.motion.state !== MotionState.ACTIVE) {
        return false
      }
      return true
    },
    layout () {
      return this.screen === 'one' ? this.$store.getters['motions/speakersListLayout'] : this.$store.getters['motions/speakersListTwoLayout']
    },
    perPage () {
      if (this.layout === 'carousel') {
        return 1
      }
      return 2
    },
    speakersFor () {
      if (!this.motion) {
        return []
      }
      if (this.limit !== null) {
        return this.motion.for.filter((speaker) => speaker.status === SpeakerState.PENDING).slice(0, this.limit)
      }
      return this.motion.for.filter((speaker) => speaker.status === SpeakerState.PENDING)
    },
    numRemainingSpeakersFor () {
      if (!this.motion) {
        return 0
      }
      const numSpeakers = this.motion.for.filter((speaker) => speaker.status === SpeakerState.PENDING).length
      console.log(`there are ${numSpeakers} speakers for, which is an excess of ${numSpeakers - this.limit}`)
      if (numSpeakers === 0 || this.limit === null) {
        return 0
      }
      if (numSpeakers <= this.limit) {
        return 0
      }
      return numSpeakers - this.limit
    },
    speakersAgainst () {
      if (!this.motion) {
        return []
      }
      if (this.limit !== null) {
        return this.motion.against.filter((speaker) => speaker.status === SpeakerState.PENDING).slice(0, this.limit)
      }
      return this.motion.against.filter((speaker) => speaker.status === SpeakerState.PENDING)
    },
    numRemainingSpeakersAgainst () {
      if (!this.motion) {
        return 0
      }
      const numSpeakers = this.motion.against.filter((speaker) => speaker.status === SpeakerState.PENDING).length
      if (numSpeakers === 0 || this.limit === null) {
        return 0
      }
      if (numSpeakers <= this.limit) {
        return 0
      }
      return numSpeakers - this.limit
    },
    allSpeakersFor () {
      if (!this.motion) {
        return []
      }
      return this.motion.for
    },
    allSpeakersAgainst () {
      if (!this.motion) {
        return []
      }
      return this.motion.against
    }
  }
}
</script>

<style scoped>
.speakers-list-compact {
  position: relative;
  width: 100%;
  height: 100%;
}
.speakers-list-compact > div {
  position: absolute;
  left: 0;
  width: 100%;
}
.speakers-list-compact .inner {
  top: 0;
  height: 100%;
}
.speakers-list-compact .fade {
  bottom: 0;
  height: 20px;
  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(212, 219, 45, 0)), to(#009db0));
  border-bottom-right-radius: 20px;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
li:not(:last-child) {
  margin-bottom: 0.5rem;
}
li {

}
.opinion-for {
  color: #222;
}
.opinion-against {
  color: #222;
}
.speaker-name {
  color: #222;
}
</style>



// WEBPACK FOOTER //
// src/components/speakers/SpeakersListCompact.vue